// extracted by mini-css-extract-plugin
export default {"bannerComponent":"vj-z","red":"wj-z","calloutlink":"xj-z","headerTopBanner":"yj-z","bgcolorRed":"zj-z","headerTopCallout":"Aj-z","searchBanner":"Bj-z","hideMobile":"Cj-z"};